<mat-label class="subHeading">Payment Mode<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select multiple class="payment" formControlName="payment_mode" [placeholder]="!isMultiSelect ? 'Select' : 'All'">
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="selectAll()"
    >
        Select All
    </button>
    <button
        *ngIf="isMultiSelect"
        class="btn selectAll"
        (click)="unSelectAll()"
    >
        Remove All
    </button>
    <mat-option (onSelectionChange)="selectionChange($event)" value="online">Online</mat-option>
    <mat-option (onSelectionChange)="selectionChange($event)" value="offline">Offline</mat-option>
</mat-select>